import React, { useState } from 'react';
import { Users, RotateCcw, Library, ShieldCheck } from 'lucide-react';
import { ui } from '../ui';

export default function LoginScreen({
  onJoin, authState, connected = true, initialName = '', initialSession = '', rejoin = null,
  onOpenLibrary, onOpenAdmin = () => {},
}) {
  const [name, setName] = useState(initialName);
  const [session, setSession] = useState(initialSession);

  const canJoin = name.trim() && session.trim() && authState !== 'pending';
  const join = () => canJoin && onJoin(name, session);

  return (
    <div className="min-h-screen bg-page flex items-center justify-center p-4">
      <div className={`${ui.panel} p-8 sm:p-10 max-w-md w-full`}>
        <div className="flex items-center justify-center mb-6">
          <div className="w-14 h-14 rounded-full bg-accent-tint flex items-center justify-center">
            <Users className="w-7 h-7 text-accent" />
          </div>
        </div>
        <h1 className="text-title font-semibold text-ink mb-1 text-center">CDM Grid</h1>
        <p className="text-body text-ink-2 mb-8 text-center">Collaborative clinical decision making</p>

        {rejoin && (
          <button
            onClick={() => onJoin(rejoin.name, rejoin.session)}
            disabled={authState === 'pending'}
            className={`${ui.btnOutline} w-full mb-5`}
          >
            <RotateCcw className="w-4 h-4" />
            Rejoin “{rejoin.session}” as {rejoin.name}
          </button>
        )}

        <div className="space-y-4">
          <div>
            <label className="text-meta font-medium text-ink-2 mb-1.5 block">Your Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              className={`${ui.input} h-11`}
            />
          </div>
          <div>
            <label className="text-meta font-medium text-ink-2 mb-1.5 block">Session ID</label>
            <input
              type="text"
              value={session}
              onChange={(e) => setSession(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && join()}
              placeholder="Create or join a session"
              className={`${ui.input} h-11`}
            />
          </div>
          <button onClick={join} disabled={!canJoin} className={`${ui.btnPrimary} w-full h-11`}>
            {authState === 'pending' ? 'Connecting…' : 'Join Session'}
          </button>
        </div>

        {!connected && (
          <p className="text-meta text-flag-red mt-4 text-center">
            No connection to the sync service, check your internet and try again.
          </p>
        )}
        <p className="text-meta text-ink-2 mt-6 text-center">Use the same Session ID to collaborate in real-time</p>

        <div className="mt-6 pt-4 border-t border-line flex items-center justify-center gap-5">
          <button onClick={onOpenLibrary} className="flex items-center gap-1.5 text-meta text-ink-2 hover:text-accent transition-colors">
            <Library className="w-3.5 h-3.5" />My case library
          </button>
          <button
            onClick={onOpenAdmin}
            className="flex items-center gap-1.5 text-meta text-ink-2 hover:text-accent transition-colors"
            title="Survey results and question setup (password protected)"
          >
            <ShieldCheck className="w-3.5 h-3.5" />Admin
          </button>
        </div>
      </div>
    </div>
  );
}
